import { GET_MEMBERSHIP_TYPES, GET_UPCOMING_WOMEN_SETS } from '@/utils/store/actionTypes'
import { serializeParameters } from '@/utils/general'

export default {
  async [GET_MEMBERSHIP_TYPES] (_, { women = false, men = true, addon = false, boys = true } = {}) { // New GetProductGroups
    const params = serializeParameters({ women, addon, boys, men }).replace(/=true&/g, ',').replace(/=true/g, '')

    const response = await this.$axios.$get(`${process.env.API_URL}/v2/membership-types?orientation=${params}`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json',
        'OTA-External': 'true' // Bypass axios plugin Authorization Header override
      }
    })

    return response
  },
  async [GET_UPCOMING_WOMEN_SETS] () {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/design-groups?orientation=women&upcoming=true`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  }
}
